import {
  CLONE_GROUP_SETTINGS_REQUEST_ASYNC,
  DELETE_GROUP_SETTINGS_REQUEST_ASYNC,
  FILTERS_CHANGE,
  FILTERS_CLEAR,
  FILTERS_SUBMIT,
  GROUP_SETTINGS_DATA_REQUEST_ASYNC,
  HANDLE_EDIT_MODE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC,
  SORT_PROPERTY_CHANGE,
} from './constants'

const fetchGroupSettings = () => ({
  type: GROUP_SETTINGS_DATA_REQUEST_ASYNC.INITIATE,
})
export const fetchGroupSettingsSuccess = (data) => ({
  type: GROUP_SETTINGS_DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchGroupSettingsError = (error) => ({
  type: GROUP_SETTINGS_DATA_REQUEST_ASYNC.ERROR,
  error,
})
const fetchGroupSettingsCancel = () => ({
  type: GROUP_SETTINGS_DATA_REQUEST_ASYNC.CANCEL,
})

export const cloneGroupSettings = (id) => ({
  type: CLONE_GROUP_SETTINGS_REQUEST_ASYNC.INITIATE,
  payload: { id },
})
export const cloneGroupSettingsSuccess = () => ({
  type: CLONE_GROUP_SETTINGS_REQUEST_ASYNC.SUCCESS,
})
export const cloneGroupSettingsError = (error) => ({
  type: CLONE_GROUP_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const cloneGroupSettingsCancel = () => ({
  type: CLONE_GROUP_SETTINGS_REQUEST_ASYNC.CANCEL,
})

export const setGroupSettingsAsDefault = (id, value) => ({
  type: SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.INITIATE,
  payload: { id, value },
})
export const setGroupSettingsAsDefaultSuccess = () => ({
  type: SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.SUCCESS,
})
export const setGroupSettingsAsDefaultError = (error) => ({
  type: SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.ERROR,
  error,
})
const setGroupSettingsAsDefaultCancel = () => ({
  type: SET_GROUP_SETTINGS_AS_DEFAULT_REQUEST_ASYNC.CANCEL,
})

export const deleteGroupSettings = (id) => ({
  type: DELETE_GROUP_SETTINGS_REQUEST_ASYNC.INITIATE,
  payload: { id },
})
export const deleteGroupSettingsSuccess = () => ({
  type: DELETE_GROUP_SETTINGS_REQUEST_ASYNC.SUCCESS,
})
export const deleteGroupSettingsError = (error) => ({
  type: DELETE_GROUP_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const deleteGroupSettingsCancel = () => ({
  type: DELETE_GROUP_SETTINGS_REQUEST_ASYNC.CANCEL,
})

export const filtersChange = (value, filterType) => ({
  type: FILTERS_CHANGE,
  payload: { value, filterType },
})
const filtersClear = () => ({ type: FILTERS_CLEAR })
const filtersSubmit = () => ({ type: FILTERS_SUBMIT })

const sortPropertyChange = (value) => ({
  type: SORT_PROPERTY_CHANGE,
  payload: { value },
})

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })

const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

const handleEditMode = (id, name, description) => ({
  type: HANDLE_EDIT_MODE,
  payload: { id, name, description },
})

export default {
  // to props
  cloneGroupSettings,
  cloneGroupSettingsCancel,
  setGroupSettingsAsDefault,
  setGroupSettingsAsDefaultCancel,
  deleteGroupSettings,
  deleteGroupSettingsCancel,
  filtersChange,
  filtersClear,
  filtersSubmit,
  fetchGroupSettings,
  fetchGroupSettingsCancel,
  sortPropertyChange,
  paginateChange,
  searchChange,
  searchReset,
  handleEditMode,
}
